var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.6673 22.3079H48.0007V8.97461H16.0007V22.3079H13.334C8.90732 22.3079 5.33398 25.8813 5.33398 30.3079V46.3079H16.0007V56.9746H48.0007V46.3079H58.6673V30.3079C58.6673 25.8813 55.094 22.3079 50.6673 22.3079ZM21.334 14.3079H42.6673V22.3079H21.334V14.3079ZM42.6673 51.6413H21.334V40.9746H42.6673V51.6413ZM48.0007 40.9746V35.6413H16.0007V40.9746H10.6673V30.3079C10.6673 28.8413 11.8673 27.6413 13.334 27.6413H50.6673C52.134 27.6413 53.334 28.8413 53.334 30.3079V40.9746H48.0007Z",
    fill: "#191919"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0007 34.3079C49.4734 34.3079 50.6673 33.114 50.6673 31.6413C50.6673 30.1685 49.4734 28.9746 48.0007 28.9746C46.5279 28.9746 45.334 30.1685 45.334 31.6413C45.334 33.114 46.5279 34.3079 48.0007 34.3079Z",
    fill: "#191919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.a965a9a182225effb416dea39551a6d2.svg";
export { ForwardRef as ReactComponent };